import { render } from "./CorporatePlanSitePlansComponent.vue?vue&type=template&id=3e652fca"
import script from "./CorporatePlanSitePlansComponent.vue?vue&type=script&lang=js"
export * from "./CorporatePlanSitePlansComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__